const BASE_URL = "https://www.yunfanpeiyou.com/api";

const FALLBACK_BOTTOM = {
  tel: "17631142036",
  email: "yfzp@yfpy.top",
  code: "050000",
  address: "河北省石家庄市裕华区富强大街19号聚星城2层010号",
  icp: "冀ICP备2025112385号-1",
  wechat: null,
  redbook: null,
};

const FALLBACK_BANNERS = [
  {
    bg: "/static/img/mask-group.png",
    title: "提升石家庄基础教育水平",
    subtitle: "Improve the level of basic education in Shijiazhuang",
  },
  {
    bg: "/static/img/mask-group-1.png",
    title: "提升石家庄基础教育水平",
    subtitle: "Improve the level of basic education in Shijiazhuang",
  },
];

const ANNOUNCEMENTS = [
  {
    id: "2026-zhongkao-good-news",
    date: "2026.9.18",
    eyebrow: "YUNFAN HONOR · 2026",
    title: "2026中考喜报｜云帆优秀学员高分榜发布",
    desc: "2026年中考成绩陆续揭晓。根据目前收集到的成绩，云帆培优学员中考裸分最高792分，多名学员达到770分及以上；数学、物理两科均有多名学员取得满分。",
    imageSrc: "/static/img/announcement-2026-total.jpg",
    images: [
      "/static/img/announcement-2026-total.jpg",
      "/static/img/announcement-2026-math.jpg",
      "/static/img/announcement-2026-physics.jpg",
    ],
    highlights: [
      { value: "792", label: "中考裸分最高" },
      { value: "120", label: "数学满分" },
      { value: "60", label: "物理满分" },
    ],
    intro: "盛夏传捷报，努力有回响。2026年中考成绩揭晓以来，云帆学员在总分及数学、物理学科均取得亮眼成绩。本次喜报按“中考总分榜—数学高分榜—物理高分榜”呈现，记录每一份扎实成长，也向所有坚持与付出致敬。",
    sections: [
      {
        number: "01",
        kicker: "TOTAL SCORE",
        title: "中考总分榜",
        desc: "阶段性统计显示，多名学员中考裸分达到770分及以上，最高792分。稳定的综合表现，是长期积累与持续投入的回响。",
        image: "/static/img/announcement-2026-total.jpg",
        alt: "2026中考云帆优秀学员中考总分榜",
        width: 1280,
        height: 2974,
      },
      {
        number: "02",
        kicker: "MATHEMATICS",
        title: "数学高分榜",
        desc: "本次数学高分榜收录成绩为115—120分，多名学员取得120分满分。扎实的知识基础与持续的思维训练，在考场上转化为亮眼表现。",
        image: "/static/img/announcement-2026-math.jpg",
        alt: "2026中考云帆优秀学员数学高分榜",
        width: 1280,
        height: 3036,
      },
      {
        number: "03",
        kicker: "PHYSICS",
        title: "物理高分榜",
        desc: "本次物理高分榜收录成绩为55—60分，多名学员取得60分满分。对概念的理解、模型的建立与规范的解题表达，在成绩中得到体现。",
        image: "/static/img/announcement-2026-physics.jpg",
        alt: "2026中考云帆优秀学员物理高分榜",
        width: 1280,
        height: 2966,
      },
    ],
    closing: "成绩是阶段性成长的见证，也是一段新旅程的起点。愿每一位同学带着这份笃定与热爱，在更广阔的天地里继续向上生长、奔赴理想。再次祝贺所有取得优异成绩的云帆学员！",
    note: "成绩为不完全统计，后续持续更新；榜单姓名均已作隐私处理。",
  },
];

async function getJSON(u) {
  try {
    const r = await fetch(u);
    if (!r.ok) throw new Error(`http_error_${r.status}`);
    return await r.json();
  } catch (error) {
    if (process.env.NODE_ENV !== "production") {
      console.warn("[api] request failed:", u, error);
    }
    return null;
  }
}
function fileUrl(id) {
  if (!id) return null;
  return `${BASE_URL}/assets/${id}`;
}
async function getBottom() {
  const j = await getJSON(`${BASE_URL}/items/bottom?limit=1`);
  const d = Array.isArray(j && j.data) ? j.data[0] : j && j.data;
  if (!d) return FALLBACK_BOTTOM;
  return {
    tel: d.tel || "",
    email: d.email || "",
    code: d.code || "",
    address: d.address || "",
    icp: d.icp || "",
    wechat: fileUrl(d.Wechat),
    redbook: fileUrl(d.redbook),
  };
}
export { getBottom };
async function getBanner() {
  const j = await getJSON(`${BASE_URL}/items/banner?sort=sort`);
  const arr = Array.isArray(j && j.data) ? j.data : [];
  const banners = arr
    .map((d) => ({ bg: fileUrl(d.img), title: d.title || "", subtitle: d.subtitle || "" }))
    .filter((d) => d.bg || d.title || d.subtitle);
  return banners.length ? banners : FALLBACK_BANNERS;
}
export { getBanner };
async function getGrades(typeLabel) {
  const enc = encodeURIComponent(typeLabel || "");
  const url = `${BASE_URL}/items/Grades?filter[type][_eq]=${enc}&sort=sort`;
  const j = await getJSON(url);
  const arr = Array.isArray(j && j.data) ? j.data : [];
  return arr.map((d) => ({
    year: d.year,
    // 首页榜单数据来自后台；在展示层校正已确认的姓名错字，不改动喜报海报。
    name: d.name === "宋*麻" ? "宋*庥" : d.name,
  }));
}
export { getGrades };
async function getArea() {
  const j = await getJSON(`${BASE_URL}/items/area?limit=1`);
  const d = Array.isArray(j && j.data) ? j.data[0] : j && j.data;
  if (!d) return null;
  return {
    huite: fileUrl(d.huite),
    xinhezuo: fileUrl(d.xinhezuo),
    hengda: fileUrl(d.hengda),
  };
}
export { getArea };
async function getAnnouncements(limit = 20) {
  return ANNOUNCEMENTS.slice(0, limit);
}
export { getAnnouncements };

async function getAnnouncementById(id) {
  return ANNOUNCEMENTS.find((item) => item.id === id) || ANNOUNCEMENTS[0];
}
export { getAnnouncementById };
